'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n\n  @font-face {\n    font-family: Open Sans;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'truetype\');\n  }\n    @font-face {\n    font-family: Open Sans;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'truetype\');\n  }\n      @font-face {\n    font-family: Open Sans;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'truetype\');\n  }\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n    @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n      @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n'], ['\n\n  @font-face {\n    font-family: Open Sans;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'truetype\');\n  }\n    @font-face {\n    font-family: Open Sans;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'truetype\');\n  }\n      @font-face {\n    font-family: Open Sans;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'truetype\');\n  }\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n    @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n      @font-face {\n    font-family: Montserrat;\n    font-weight: ', ';\n    src: url(\'', '\') format(\'opentype\'),\n      url(\'', '\') format(\'truetype\');\n  }\n']);

var _styledComponents = require('styled-components');

var _MontserratLight = require('./fonts/Montserrat/Montserrat-Light.otf');

var _MontserratLight2 = _interopRequireDefault(_MontserratLight);

var _MontserratLight3 = require('./fonts/Montserrat/Montserrat-Light.ttf');

var _MontserratLight4 = _interopRequireDefault(_MontserratLight3);

var _MontserratRegular = require('./fonts/Montserrat/Montserrat-Regular.otf');

var _MontserratRegular2 = _interopRequireDefault(_MontserratRegular);

var _MontserratRegular3 = require('./fonts/Montserrat/Montserrat-Regular.ttf');

var _MontserratRegular4 = _interopRequireDefault(_MontserratRegular3);

var _MontserratMedium = require('./fonts/Montserrat/Montserrat-Medium.otf');

var _MontserratMedium2 = _interopRequireDefault(_MontserratMedium);

var _MontserratMedium3 = require('./fonts/Montserrat/Montserrat-Medium.ttf');

var _MontserratMedium4 = _interopRequireDefault(_MontserratMedium3);

var _MontserratBold = require('./fonts/Montserrat/Montserrat-Bold.otf');

var _MontserratBold2 = _interopRequireDefault(_MontserratBold);

var _MontserratBold3 = require('./fonts/Montserrat/Montserrat-Bold.ttf');

var _MontserratBold4 = _interopRequireDefault(_MontserratBold3);

var _MontserratExtraBold = require('./fonts/Montserrat/Montserrat-ExtraBold.ttf');

var _MontserratExtraBold2 = _interopRequireDefault(_MontserratExtraBold);

var _MontserratExtraBold3 = require('./fonts/Montserrat/Montserrat-ExtraBold.otf');

var _MontserratExtraBold4 = _interopRequireDefault(_MontserratExtraBold3);

var _MontserratSemiBold = require('./fonts/Montserrat/Montserrat-SemiBold.otf');

var _MontserratSemiBold2 = _interopRequireDefault(_MontserratSemiBold);

var _MontserratSemiBold3 = require('./fonts/Montserrat/Montserrat-SemiBold.ttf');

var _MontserratSemiBold4 = _interopRequireDefault(_MontserratSemiBold3);

var _OpenSansRegular = require('./fonts/OpenSans/OpenSans-Regular.ttf');

var _OpenSansRegular2 = _interopRequireDefault(_OpenSansRegular);

var _OpenSansBold = require('./fonts/OpenSans/OpenSans-Bold.ttf');

var _OpenSansBold2 = _interopRequireDefault(_OpenSansBold);

var _OpenSansExtraBold = require('./fonts/OpenSans/OpenSans-ExtraBold.ttf');

var _OpenSansExtraBold2 = _interopRequireDefault(_OpenSansExtraBold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

exports.default = (0, _styledComponents.css)(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeightRegular;
}, _OpenSansRegular2.default, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeightBold;
}, _OpenSansBold2.default, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeightHeavyBold;
}, _OpenSansExtraBold2.default, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeightLight;
}, _MontserratLight2.default, _MontserratLight4.default, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeightRegular;
}, _MontserratRegular2.default, _MontserratRegular4.default, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeightMedium;
}, _MontserratMedium2.default, _MontserratMedium4.default, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeightBold;
}, _MontserratBold2.default, _MontserratBold4.default, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeightHeavyBold;
}, _MontserratExtraBold4.default, _MontserratExtraBold2.default, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeightSemiBold;
}, _MontserratSemiBold2.default, _MontserratSemiBold4.default);
module.exports = exports['default'];